export default __webpack_public_path__ + "static/backgroundFeatures-81bde111c49a4ca6f3cd6eff70384df3.jpg";